import React from 'react';
import './NavigationPage.css';
import { GrClose } from 'react-icons/gr';
import { TbBeach } from 'react-icons/tb'; // import hotel icon
import { FaInstagram, FaFacebookF } from 'react-icons/fa';
import { SOCIAL_LINKS } from '../config/socialLinks';
import CustomLink from './CustomLink';
import { Link  } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import LanguageSwitcher from './LanguageSwitcher';
import logo_nav_page from '../assets/photos/logo-missive-green-final.png'; 


const NavigationPage = ({ closeNav }) => {
    const { t } = useLanguage();
    const combinedClickHandler = () => {
        window.scroll(0, 0);
        closeNav();
      };
    return (
        <div className="nav-page">
            {/* Header section */}
            <div className="nav-header">
                <div className="nav-header-left">
                    <LanguageSwitcher bgColor="white" />
                </div>

                <Link 
                    to={'/'} 
                    onClick={() => {
                        window.scroll(0, 0);
                        combinedClickHandler();
                    }}
                    >
                    <img className="logo-nav-page" src={logo_nav_page} alt="Logo" />
                </Link>

                <div className="nav-header-right">
                    <div className="close-icon" onClick={closeNav}>
                        <GrClose size={30} />
                    </div>
                </div>
            </div>

            {/* Main content - split layout */}
            <div className="nav-content-wrapper">
                {/* Left side - Menu links */}
                <div className="nav-menu-section">
                    <div className="nav-links-main">
                        <div className="nav-links">
                            <Link to={'/'} onClick={combinedClickHandler}>{t('navigationPage.home')}</Link>
                            <CustomLink to="/" section="gallery-photos" onClick={closeNav}>{t('navigationPage.photos')}</CustomLink>
                            <CustomLink to="/" section="room-type" onClick={closeNav}>{t('navigationPage.suites')}</CustomLink>
                            <Link to={'/VirtualTour'} onClick={combinedClickHandler}>{t('navigationPage.virtualTour')}</Link>
                        </div>

                        <div className="nav-links">
                            <Link to={'/LuxurySuites'} onClick={combinedClickHandler}>{t('navigationPage.luxurySuite')}</Link>
                            <Link to={'/LuxuryVips'} onClick={combinedClickHandler}>{t('navigationPage.luxuryVips')}</Link>
                            <Link to={'/LuxuryDomi'} onClick={combinedClickHandler}>{t('navigationPage.luxuryDomi')}</Link>
                            <Link to={'/LuxuryVilla'} onClick={combinedClickHandler}>
                                {t('navigationPage.luxuryVilla')}
                                <span className="nav-sub-label">{t('navigationPage.luxuryVillaSubtitle')}</span>
                            </Link>
                        </div>
                    </div>

                    <div className="nav-separator-mobile"></div>

                    <div className="nav-links nav-links-small">
                        <Link to={'/Tos'} onClick={combinedClickHandler}>{t('navigationPage.tos')}</Link>
                        <Link to={'/Negishot'} onClick={combinedClickHandler}>{t('navigationPage.accessibility')}</Link>
                        <Link to={'/Kosher'} onClick={combinedClickHandler}>{t('navigationPage.kosher')}</Link>
                        <Link to={'/Restaurants'} onClick={combinedClickHandler}>{t('navigationPage.restaurants')}</Link>
                        <a className="nav-guide-link" href="/guide/">{t('navigationPage.guestGuide')}</a>
                    </div>
                </div>

                {/* Right side - Slogan */}
                <div className="nav-slogan-section">
                    <div className="nav-slogan">
                        <h2 className="slogan-line-1">{t('navigationPage.sloganLine1')}</h2>
                        <h2 className="slogan-line-2">{t('navigationPage.sloganLine2')}</h2>
                        <p className="slogan-subtitle">{t('navigationPage.sloganSubtitle')}</p>
                        <div className="slogan-divider"></div>
                        <p className="slogan-tagline">{t('navigationPage.sloganTagline')}</p>
                    </div>
                </div>
            </div>

            {/* Footer - Contact info */}
            <div className="nav-footer">
                <div className="nav-social-row">
                    <a href={SOCIAL_LINKS.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"><FaInstagram /></a>
                    <a href={SOCIAL_LINKS.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook"><FaFacebookF /></a>
                </div>
                <a className="phone" href="tel:+97249806006"><span className="phone-icon">📞</span><span>{t('navigation.phone')}</span></a>
                <div className="nav-address">{t('navigationPage.address')}</div>
            </div>

        </div>
    );
};

export default NavigationPage;
